/* global SideDrawer */

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              // Add event listener to new buttons
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });

              // Remove event listener from removed buttons
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });

          // Start observing changes to the DOM
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }

      this.badgeHelperData = {
        productId: null,
        freeShipping: false,
        quickShip: false,
        quickShipBadgeHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="84" height="24" viewBox="0 0 84 24" fill="none"
                             class="quickship-badge">
          <path d="M0 5C0 2.23858 2.23858 0 5 0H84V19C84 21.7614 81.7614 24 79 24H0V5Z" fill="#FFE151"></path>
          <g clip-path="url(#clip0_2225_656)">
            <path
                d="M17.98 10.651C17.9621 10.6174 17.9352 10.5894 17.9024 10.57C17.8696 10.5506 17.8321 10.5406 17.794 10.541H15.354L17.762 7.04101C17.7819 7.01308 17.7932 6.97996 17.7947 6.9457C17.7961 6.91144 17.7875 6.8775 17.77 6.84801C17.7509 6.81766 17.7243 6.79272 17.6928 6.77556C17.6613 6.75841 17.6259 6.74961 17.59 6.75001H14.293C14.215 6.75001 14.143 6.79001 14.109 6.85501L11.022 12.542C11.0062 12.5706 10.9986 12.6031 11.0002 12.6358C11.0018 12.6685 11.0125 12.7001 11.031 12.727C11.0506 12.7552 11.0768 12.7781 11.1073 12.7938C11.1378 12.8095 11.1717 12.8174 11.206 12.817H13.323L11.016 17.862C10.9973 17.9043 10.9953 17.9521 11.0106 17.9957C11.0258 18.0394 11.0571 18.0756 11.098 18.097C11.1403 18.1208 11.1894 18.1298 11.2374 18.1225C11.2854 18.1153 11.3296 18.0922 11.363 18.057L17.952 10.854C17.9772 10.8273 17.9935 10.7935 17.9987 10.7571C18.0039 10.7208 17.9977 10.6837 17.981 10.651H17.98Z"
                fill="#1A1919"></path>
          </g>
          <path
              d="M31.4201 12.4209C31.4201 12.9775 31.3485 13.4854 31.2053 13.9443C31.062 14.4033 30.8472 14.7956 30.5607 15.1211C30.2743 15.4466 29.913 15.6924 29.4768 15.8584L31.176 17.6992H29.6135L28.2707 16.0928C28.2382 16.0928 28.2056 16.0928 28.173 16.0928C28.1437 16.096 28.1145 16.0977 28.0852 16.0977C27.5155 16.0977 27.0207 16.0098 26.6008 15.834C26.1841 15.6582 25.8374 15.4076 25.5607 15.082C25.2873 14.7565 25.0822 14.3675 24.9455 13.915C24.8088 13.4626 24.7404 12.9613 24.7404 12.4111C24.7404 11.6755 24.8609 11.0342 25.1018 10.4873C25.3459 9.93717 25.7154 9.51074 26.2102 9.20801C26.7082 8.90202 27.3365 8.74902 28.0949 8.74902C28.8371 8.74902 29.454 8.90039 29.9455 9.20312C30.437 9.50586 30.8049 9.93229 31.049 10.4824C31.2964 11.0293 31.4201 11.6755 31.4201 12.4209ZM25.9709 12.4209C25.9709 12.971 26.0458 13.4479 26.1955 13.8516C26.3452 14.252 26.5747 14.5612 26.884 14.7793C27.1965 14.9941 27.5969 15.1016 28.0852 15.1016C28.5767 15.1016 28.9771 14.9941 29.2863 14.7793C29.5956 14.5612 29.8234 14.252 29.9699 13.8516C30.1164 13.4479 30.1896 12.971 30.1896 12.4209C30.1896 11.5843 30.022 10.93 29.6867 10.458C29.3547 9.98275 28.8241 9.74512 28.0949 9.74512C27.6066 9.74512 27.2046 9.85254 26.8889 10.0674C26.5764 10.2822 26.3452 10.5898 26.1955 10.9902C26.0458 11.3874 25.9709 11.8643 25.9709 12.4209ZM38.3588 8.86133V13.4805C38.3588 13.9785 38.253 14.4245 38.0414 14.8184C37.8331 15.2122 37.5173 15.5247 37.0941 15.7559C36.671 15.9837 36.1387 16.0977 35.4975 16.0977C34.5827 16.0977 33.8861 15.8584 33.4076 15.3799C32.9324 14.8981 32.6947 14.2585 32.6947 13.4609V8.86133H33.8666V13.3584C33.8666 13.9541 34.0066 14.3936 34.2865 14.6768C34.5665 14.96 34.9848 15.1016 35.5414 15.1016C35.9255 15.1016 36.238 15.0348 36.4789 14.9014C36.723 14.7646 36.9021 14.5661 37.016 14.3057C37.1332 14.042 37.1918 13.7246 37.1918 13.3535V8.86133H38.3588ZM39.985 16V8.86133H41.1568V16H39.985ZM45.8836 9.75488C45.5418 9.75488 45.2358 9.81673 44.9656 9.94043C44.6987 10.0641 44.4725 10.2432 44.2869 10.4775C44.1014 10.7087 43.9598 10.9902 43.8621 11.3223C43.7645 11.651 43.7156 12.0221 43.7156 12.4355C43.7156 12.9889 43.7937 13.4658 43.95 13.8662C44.1062 14.2633 44.3439 14.5693 44.6629 14.7842C44.9819 14.9958 45.3855 15.1016 45.8738 15.1016C46.1766 15.1016 46.4712 15.0723 46.7576 15.0137C47.0441 14.9551 47.3403 14.8753 47.6463 14.7744V15.7705C47.3566 15.8844 47.0636 15.9674 46.7674 16.0195C46.4712 16.0716 46.1294 16.0977 45.742 16.0977C45.0128 16.0977 44.4074 15.9463 43.9256 15.6436C43.4471 15.3408 43.089 14.9144 42.8514 14.3643C42.617 13.8141 42.4998 13.1696 42.4998 12.4307C42.4998 11.8903 42.5747 11.3955 42.7244 10.9463C42.8742 10.4971 43.0923 10.1097 43.3787 9.78418C43.6652 9.4554 44.0184 9.20312 44.4383 9.02734C44.8615 8.84831 45.3449 8.75879 45.8885 8.75879C46.2465 8.75879 46.5981 8.79948 46.9432 8.88086C47.2915 8.95898 47.6137 9.07129 47.91 9.21777L47.4998 10.1846C47.2524 10.0674 46.9936 9.96647 46.7234 9.88184C46.4533 9.7972 46.1733 9.75488 45.8836 9.75488ZM54.4238 16H53.0762L50.8545 12.7578L50.1514 13.3291V16H48.9795V8.86133H50.1514V12.2744C50.2946 12.0986 50.4395 11.9229 50.5859 11.7471C50.7324 11.5713 50.8789 11.3955 51.0254 11.2197L53.0371 8.86133H54.3604L51.6943 11.9863L54.4238 16ZM59.2873 14.0566C59.2873 14.4798 59.1831 14.8444 58.9748 15.1504C58.7697 15.4564 58.4735 15.6908 58.0861 15.8535C57.702 16.0163 57.243 16.0977 56.7092 16.0977C56.4488 16.0977 56.1997 16.083 55.9621 16.0537C55.7245 16.0244 55.4999 15.9821 55.2883 15.9268C55.0799 15.8682 54.8895 15.7982 54.717 15.7168V14.6133C55.0067 14.7402 55.3306 14.8558 55.6887 14.96C56.0467 15.0609 56.4113 15.1113 56.7824 15.1113C57.0852 15.1113 57.3358 15.0723 57.5344 14.9941C57.7362 14.9128 57.8859 14.7988 57.9836 14.6523C58.0812 14.5026 58.1301 14.3285 58.1301 14.1299C58.1301 13.9183 58.0731 13.7393 57.9592 13.5928C57.8452 13.4463 57.6727 13.3128 57.4416 13.1924C57.2137 13.0687 56.9273 12.9368 56.5822 12.7969C56.3479 12.7025 56.1232 12.5951 55.9084 12.4746C55.6968 12.3542 55.508 12.2126 55.342 12.0498C55.176 11.887 55.0441 11.695 54.9465 11.4736C54.8521 11.249 54.8049 10.9854 54.8049 10.6826C54.8049 10.279 54.9009 9.93392 55.093 9.64746C55.2883 9.361 55.5617 9.14128 55.9133 8.98828C56.2681 8.83529 56.6815 8.75879 57.1535 8.75879C57.5279 8.75879 57.8794 8.79785 58.2082 8.87598C58.5402 8.9541 58.8658 9.06478 59.1848 9.20801L58.8137 10.1504C58.5207 10.0299 58.2359 9.93392 57.9592 9.8623C57.6857 9.79069 57.4058 9.75488 57.1193 9.75488C56.8719 9.75488 56.662 9.79232 56.4895 9.86719C56.3169 9.94206 56.1851 10.0479 56.0939 10.1846C56.0061 10.318 55.9621 10.4775 55.9621 10.6631C55.9621 10.8714 56.0126 11.0472 56.1135 11.1904C56.2176 11.3304 56.3771 11.459 56.592 11.5762C56.8101 11.6934 57.09 11.8236 57.4318 11.9668C57.8257 12.1296 58.1594 12.3005 58.4328 12.4795C58.7095 12.6585 58.9211 12.8734 59.0676 13.124C59.2141 13.3714 59.2873 13.6823 59.2873 14.0566ZM66.0941 16H64.9271V12.7773H61.6361V16H60.4643V8.86133H61.6361V11.7812H64.9271V8.86133H66.0941V16ZM67.7838 16V8.86133H68.9557V16H67.7838ZM72.7156 8.86133C73.6368 8.86133 74.3091 9.05013 74.7322 9.42773C75.1554 9.80534 75.367 10.3343 75.367 11.0146C75.367 11.3239 75.3182 11.6185 75.2205 11.8984C75.1261 12.1751 74.9699 12.4209 74.7518 12.6357C74.5337 12.8473 74.2456 13.015 73.8875 13.1387C73.5327 13.2624 73.0949 13.3242 72.574 13.3242H71.8123V16H70.6404V8.86133H72.7156ZM72.6375 9.83301H71.8123V12.3477H72.452C72.8198 12.3477 73.1323 12.3053 73.3895 12.2207C73.6466 12.1328 73.8419 11.9945 73.9754 11.8057C74.1089 11.6169 74.1756 11.3678 74.1756 11.0586C74.1756 10.6452 74.0503 10.3376 73.7996 10.1357C73.5522 9.93392 73.1648 9.83301 72.6375 9.83301Z"
              fill="black"></path>
          <defs>
            <clipPath id="clip0_2225_656">
              <rect width="12" height="12" fill="white" transform="translate(8 6)"></rect>
            </clipPath>
          </defs>
        </svg>`
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    /**
     * Bind a mouseenter event to a given quick add button if it's not already bound
     * @param {Element} button - The button element to bind the mouseenter event to.
     */
    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    /**
     * Start the fetch on hover of a quick add button for perceived performance gains
     * @param {object} evt - Event object.
     */
    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    /**
     * Handles 'click' events on success notification's 'View cart' link
     * @param {object} evt - Event object.
     */
    handleOpenCartClick(evt) {
      // Open the cart drawer if available on the page
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-quick-add')) return;

      // Close the cart drawer if it's open
      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';

        this.cartDrawer.close();

        // Wait a few ms for a more optimal ux/animation
        setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

    /**
     * Handles 'on:variant:change' events on the Quick Add drawer.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      let url = this.productUrl;

      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;
      }

      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });
    }

    /**
     * Opens the drawer and fetches the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');

      this.getStatusBasedOnExistingBadges(opener);

      if (this.notification) this.notification.hidden = true;

      // If it's the same product as previously shown, there's no need to re-fetch the details.
      if (this.productUrl && this.productUrl === opener.dataset.productUrl) {
        super.open(opener);
        if (opener.dataset.selectedColor) this.setActiveVariant(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      this.content.innerHTML = '';
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.js-product');
        this.renderProduct(opener);
      }

      this.fetch = null;

      opener.removeAttribute('aria-disabled');
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }

    /**
     * Gets product status without request
     * @param element
     */
    getStatusBasedOnExistingBadges(element) {
      let topLevelElement = element.closest('.slider__item') || element.closest('.card');

      this.badgeHelperData.productId = element.closest('[data-item-id]').getAttribute('data-item-id');
      if (topLevelElement.querySelector('.free-shipping-badge')) {
        this.badgeHelperData.freeShipping = true;
      }
      if (topLevelElement.querySelector('.quickship-badge')) {
        this.badgeHelperData.quickShip = true;
      }
    }

    /**
     * Renders the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    renderProduct(opener) {
      // Replace instances of section id to prevent duplicates on the product page.
      const sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');

      // Prevent variant picker from updating the URL on change.
      const variantPicker = this.productEl.querySelector('variant-picker');
      if (variantPicker) variantPicker.dataset.updateUrl = 'false';

      // Remove size chart modal and link (if they exist).
      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) {
        sizeChartModal.remove();
      }

      this.updateContent();
      this.updateForm();

      // Update the product media.
      const activeMedia = this.productEl.querySelector('.media-viewer__item.is-current-variant');
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);

      if (opener.dataset.selectedColor) {
        // Timeout to allow the VariantPicker to initialize
        setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }
    }

    /**
     * Set color variant to match the one selected in the card.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`);
      if (colorOptionBox) {
        this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`)
            .click();
      } else {
        const colorOptionDropdown = this.querySelector(
            `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );
        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    /**
     * Updates the product media.
     * @param {string} mediaId - Id of the media item to show.
     */
    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const src = img.src ? img.src.split('&width=')[0] : img.dataset.src.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      const width = container.offsetWidth;
      const aspectRatio = img.width / img.height;

      container.innerHTML = `
        <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x" width="${width * 2}" height="${(width * 2) / aspectRatio}" alt="${img.alt}">
      `;
    }

    /**
     * Builds the markup for the drawer content element.
     */
    updateContent() {
      let weightElem = this.getElementHtml('.product-info__weight');
      if (weightElem && weightElem.length > 0) {
        weightElem = `<div class="product-info__weight text-sm mt-2">${weightElem}</div>`;
      }

      if (this.badgeHelperData.productId) {
        this.content.setAttribute('data-item-id', this.badgeHelperData.productId);
      }

      this.content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media${theme.settings.blendProductImages ? ' image-blend' : ''}"></div>
          <div class="quick-add-info__details">
            <div class="product-vendor-sku mb-2 text-sm">
              ${this.getElementHtml('.product-vendor-sku')}
            </div>
            <div class="product-title">
              <a class="h6 js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml('.product-title')}
              </a>
            </div>
            ${weightElem}
            <hr>
            <div class="product-price">
              ${this.getElementHtml('.product-price')}
            </div>
            <div class="cart-item-badges">
              ${this.badgeHelperData.freeShipping ? '<div class="free-shipping-badge">\n' + '<span>Free</span>&nbsp;<span>Shipping</span>\n' + '</div>' : ''}
              ${this.badgeHelperData.quickShip ? this.badgeHelperData.quickShipBadgeHtml : ''}
            </div>
            <div class="text-theme-light text-sm mt-4">
              <a href="${this.productUrl}" class="link js-prod-link">
                ${theme.strings.viewDetails}
              </a>
            </div>
          </div>
          <div class="quick-add-info__details md:hidden"></div>
        </div>
        <div class="product-options">
          ${this.getElementHtml('.product-options')}
        </div>
        <div class="product-backorder">
          ${this.getElementHtml('.product-backorder')}
        </div>
      `;

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
    }

    /**
     * Updates the Quick Add drawer form (buy buttons).
     */
    updateForm() {
      const productForm = this.productEl.querySelector('product-form');
      this.footer.classList.remove('quick-add__footer-message');

      if (productForm) {
        this.form.innerHTML = productForm.innerHTML;
        this.form.init();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      } else {
        const signUpForm = this.productEl.querySelector('.product-signup');
        if (signUpForm) {
          this.form.innerHTML = signUpForm.innerHTML;
        } else {
          this.footer.classList.add('quick-add__footer-message');
          this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>`;
        }
      }

      this.footer.classList.remove('drawer__footer--out');
    }

    /**
     * Gets the innerHTML of an element within the product element.
     * @param {string} selector - CSS selector for the element.
     * @returns {?string}
     */
    getElementHtml(selector) {
      const el = this.productEl.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows an "Added to cart" message in the drawer.
     */
    addedToCart() {
      if (this.notification) {
        setTimeout(() => {
          this.notification.hidden = false;
        }, 300);

        setTimeout(() => {
          this.notification.hidden = true;
        }, this.notification.dataset.visibleFor);
      }
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}
